import { FLAG_NAMES } from "../flag-constants";
import { SettingsConfig } from "../settings-type";

const developmentSettings: Partial<SettingsConfig> = {
  [FLAG_NAMES.DATADOG_RUM_ENABLED]: false,
};

export default developmentSettings;
